import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Grid,
    IconButton,
    Divider,
    Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AddSoOlympiad = ({ closePopup, modalData }) => {
    const [oldData, setOldData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [historyLoading, setHistoryLoading] = useState(false);

    const [formData, setFormData] = useState({
        registration_invoice_no: "",
        registration_invoiced_amount: "",
        registration_invoice_date: "",

        study_material_invoice_no: "",
        study_material_invoiced_amount: "",
        study_material_invoice_date: "",
    });

    // ================= GET OLD DATA =================
    useEffect(() => {
        if (modalData?.regId) {
            getOldData();
        }
    }, [modalData?.regId]);

    const getOldData = async () => {
        try {
            if (!modalData?.regId) return;

            setHistoryLoading(true);

            const result =
                await window.Platform.database.getSOBOforOlympiadByRegId({
                    regId: modalData.regId,
                });

            if (result?.status) {
                setOldData(result?.data || []);
            } else {
                setOldData([]);
            }
        } catch (error) {
            console.log(error);
            setOldData([]);
        } finally {
            setHistoryLoading(false);
        }
    };

    // ================= HANDLE CHANGE =================
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // ================= SUBMIT =================
    const handleSubmit = async () => {

        const registrationFields = [
            formData.registration_invoice_no,
            formData.registration_invoiced_amount,
            formData.registration_invoice_date,
        ];

        const isRegistrationFilled = registrationFields.some(
            (field) => field?.toString().trim() !== ""
        );

        const isRegistrationComplete = registrationFields.every(
            (field) => field?.toString().trim() !== ""
        );

        const studyMaterialFields = [
            formData.study_material_invoice_no,
            formData.study_material_invoiced_amount,
            formData.study_material_invoice_date,
        ];

        const isStudyMaterialFilled = studyMaterialFields.some(
            (field) => field?.toString().trim() !== ""
        );

        const isStudyMaterialComplete = studyMaterialFields.every(
            (field) => field?.toString().trim() !== ""
        );

        if (!isRegistrationFilled && !isStudyMaterialFilled) {
            window.NotificationUtils.showError(
                "Please fill at least one section"
            );
            return;
        }


        if (isRegistrationFilled && !isRegistrationComplete) {
            window.NotificationUtils.showError(
                "Please fill all Registration fields"
            );
            return;
        }

        if (isStudyMaterialFilled && !isStudyMaterialComplete) {
            window.NotificationUtils.showError(
                "Please fill all Study Material fields"
            );
            return;
        }

        try {
            setLoading(true);

            const payload = {
                regId: modalData?.regId || "",
                partyId: modalData?.partyId || "",
                userId: modalData?.userId || "",

                registration_invoice_no: formData.registration_invoice_no,
                registration_amount: formData.registration_invoiced_amount,
                registration_invoice_date: formData.registration_invoice_date,

                study_material_invoice_no: formData.study_material_invoice_no,
                study_material_amount: formData.study_material_invoiced_amount,
                study_material_invoice_date: formData.study_material_invoice_date,
            };

            const result = await window.Platform.database.saveSOBOforOlympiad(payload);

            if (result?.status) {
                window.NotificationUtils.showSuccess(result?.message || "Added successfully");

                closePopup();

                // refresh old data
                getOldData();

                // clear form
                setFormData({
                    registration_invoice_no: "",
                    registration_invoiced_amount: "",
                    registration_invoice_date: "",

                    study_material_invoice_no: "",
                    study_material_invoiced_amount: "",
                    study_material_invoice_date: "",
                });
            } else {
                window.NotificationUtils.showError(
                    result?.message || "Something went wrong"
                );
            }
        } catch (error) {
            console.log(error);
            window.NotificationUtils.showError("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box p={2} position="relative">
            <Typography variant="h5" mb={2}> Add SO </Typography>

            <Typography>
                <span style={{ fontSize: "16px", color: "#000" }}> RNO ID: {modalData?.rno_id}</span> |
                <span style={{ fontSize: "16px", color: "#000", marginLeft: "10px" }}> RM Name: {modalData?.userName}</span> |
                <span style={{ fontSize: "16px", color: "#000", marginLeft: "10px" }}> Party Name: {modalData?.schoolName} ({modalData?.partyId})</span>
            </Typography>

            <IconButton aria-label="close" onClick={closePopup} sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], zIndex: 1, }}>
                <CloseIcon />
            </IconButton>

            <Divider sx={{ my: 2, width: "100%", opacity: 1, borderTop: "1px solid #000", }} />

            {/* ================= OLD PREFILLED DATA ================= */}

            {historyLoading ? (
                <Typography mb={2}>Loading...</Typography>
            ) : (
                oldData?.map((item, index) => (
                    <Paper
                        key={item?.id || index}
                        elevation={2}
                        sx={{ p: 2, mb: 3, background: "#f5f5f5", }} >
                        <Typography variant="h6" mb={2} fontWeight={700}>
                            Previous Entry {index + 1}
                        </Typography>

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <TextField fullWidth disabled label="Registration Invoice No" value={item?.registration_invoice_no || ""} />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <TextField fullWidth disabled label="Registration Amount" value={item?.registration_amount || ""} />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <TextField fullWidth disabled type="date" label="Registration Invoice Date"
                                    value={
                                        item?.registration_invoice_date
                                            ? item.registration_invoice_date
                                                .split("T")[0]
                                            : ""
                                    }
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <TextField fullWidth disabled label="Study Material Invoice No" value={item?.study_material_invoice_no || ""} />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <TextField fullWidth disabled label="Study Material Amount" value={item?.study_material_amount || ""} />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <TextField fullWidth disabled type="date" label="Study Material Invoice Date"
                                    value={
                                        item?.study_material_invoice_date
                                            ? item.study_material_invoice_date
                                                .split("T")[0]
                                            : ""
                                    }
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                        </Grid>
                    </Paper>

                ))
            )}

            {/* ================= NEW FORM ================= */}

            <Typography variant="h6" mb={2} fontWeight={700}>
                Add New Entry
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Registration Invoice No"
                        name="registration_invoice_no"
                        value={formData.registration_invoice_no}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        type="number"
                        label="Registration Amount"
                        name="registration_invoiced_amount"
                        value={formData.registration_invoiced_amount}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        type="date"
                        label="Registration Invoice Date"
                        name="registration_invoice_date"
                        value={formData.registration_invoice_date}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        label="Study Material Invoice Number"
                        name="study_material_invoice_no"
                        value={formData.study_material_invoice_no}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        type="number"
                        label="Study Material Amount"
                        name="study_material_invoiced_amount"
                        value={formData.study_material_invoiced_amount}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        type="date"
                        label="Study Material Invoice Date"
                        name="study_material_invoice_date"
                        value={formData.study_material_invoice_date}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Box
                        display="flex"
                        justifyContent="flex-end"
                        gap={2}
                        mt={2}
                    >
                        <Button
                            variant="outlined"
                            onClick={closePopup}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? "Submitting..." : "Submit"}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AddSoOlympiad;